import Highchart from './components/Highchart/Highchart.js'


window.addEventListener('DOMContentLoaded', () => {
    const highcharts = [...document.querySelectorAll('[data-highchart]')];
    for (let highchart of highcharts) {
        new Highchart(highchart)
    }
})
